import React from 'react';
import { Zap } from 'lucide-react';
export function UrgencyBar() {
  return <div className="bg-sage-800 text-cream py-2.5 px-4 text-center sticky top-0 z-50 shadow-sm" data-id="element-179">
      <p className="text-xs md:text-sm font-medium tracking-wider flex items-center justify-center gap-2" data-id="element-180">
        <Zap size={16} className="text-yellow-400 fill-yellow-400" data-id="element-181" />
        OFERTA DE LANZAMIENTO: 80% DE DESCUENTO SOLO POR TIEMPO LIMITADO
      </p>
    </div>;
}